import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  width: 40px;
`;

const CostSummaryItem = props => (
  <StyledContentLoader {...props} viewBox="0 0 40 20">
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="100%" />
  </StyledContentLoader>
);

export default CostSummaryItem;
